import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const LoginPage = lazy(() => import('../pages/login/page'));
const HomePage = lazy(() => import('../pages/home/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const CatalogoMedicamentosPage = lazy(() => import('../pages/catalogo-medicamentos/page'));
const ClientesProveedoresPage = lazy(() => import('../pages/clientes-proveedores/page'));
const ComprasPage = lazy(() => import('../pages/compras/page'));
const RecepcionTecnicaPage = lazy(() => import('../pages/recepcion-tecnica/page'));
const RecepcionFormPage = lazy(() => import('../pages/recepcion-tecnica/RecepcionFormPage'));
const RecepcionManualPage = lazy(() => import('../pages/recepcion-tecnica/RecepcionManualPage'));

// Static import for debugging/fixing 404
import RequisicionFormPage from '../pages/compras/RequisicionFormPage';
import CotizacionFormPage from '../pages/compras/CotizacionFormPage';
import CompletarCotizacionPage from '../pages/compras/CompletarCotizacionPage';
import SeleccionRequisicionPage from '../pages/compras/SeleccionRequisicionPage';
const OrdenesCompraPage = lazy(() => import('../pages/compras/OrdenesCompraPage'));
const InventarioPage = lazy(() => import('../pages/inventario/page'));
const DispensacionPage = lazy(() => import('../pages/dispensacion/page'));
const NuevaDispensacionPage = lazy(() => import('../pages/dispensacion/NuevaDispensacionPage'));
const EntregaPendientesPage = lazy(() => import('../pages/dispensacion/EntregaPendientesPage'));
const TrasladosPage = lazy(() => import('../pages/traslados/page'));
const NuevoTrasladoPage = lazy(() => import('../pages/traslados/NuevoTrasladoPage'));
const RecepcionTrasladoPage = lazy(() => import('../pages/traslados/RecepcionTrasladoPage'));
const ReportesPage = lazy(() => import('../pages/reportes/page'));
const ReporteDispensacionesPage = lazy(() => import('../pages/reportes/ReporteDispensacionesPage'));
const ReportePendientesPage = lazy(() => import('../pages/reportes/ReportePendientesPage'));
const ReporteInventarioPage = lazy(() => import('../pages/reportes/ReporteInventarioPage'));
const ReporteVencimientosPage = lazy(() => import('../pages/reportes/ReporteVencimientosPage'));
const ReportePT030Page = lazy(() => import('../pages/reportes/ReportePT030Page'));
const GestionEspecialPage = lazy(() => import('../pages/gestion-especial/page'));
const UsuariosPage = lazy(() => import('../pages/usuarios/page'));
const BodegasPage = lazy(() => import('../pages/bodegas/page'));
const SeleccionBodegaPage = lazy(() => import('../pages/bodegas/SeleccionBodegaPage'));
const MaestroLotesPage = lazy(() => import('../pages/maestros/lotes/page'));
const PacientesPage = lazy(() => import('../pages/pacientes/page'));
const DispensacionesPacientePage = lazy(() => import('../pages/pacientes/DispensacionesPacientePage'));
const DevolucionesPage = lazy(() => import('../pages/devoluciones/page'));
const NuevaDevolucionPage = lazy(() => import('../pages/devoluciones/NuevaDevolucionPage'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PerfilPage = lazy(() => import('../pages/perfil/page'));
const LaboratoriosPage = lazy(() => import('../pages/laboratorios/page'));
const MedicamentosVigentesPage = lazy(() => import('../pages/medicamentos-vigentes/page'));

// Dispensación con Fórmula Médica
const ListadoPacientesFormulaPage = lazy(() => import('../pages/dispensacion-formula/ListadoPacientesFormulaPage'));
const PerfilPacienteFormulaPage = lazy(() => import('../pages/dispensacion-formula/PerfilPacienteFormulaPage'));
const DispensacionFormulaOperativaPage = lazy(() => import('../pages/dispensacion-formula/DispensacionFormulaOperativaPage'));
const EntregaPendientesFormulaPage = lazy(() => import('../pages/dispensacion-formula/EntregaPendientesFormulaPage'));

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '/catalogo-medicamentos',
    element: <CatalogoMedicamentosPage />
  },
  {
    path: '/clientes-proveedores',
    element: <ClientesProveedoresPage />
  },
  {
    path: '/compras',
    element: <ComprasPage />
  },
  {
    path: '/recepcion-tecnica',
    element: <RecepcionTecnicaPage />
  },
  {
    path: '/recepcion-tecnica/nueva',
    element: <RecepcionFormPage />
  },
  {
    path: '/recepcion-tecnica/nueva-factura',
    element: <RecepcionManualPage />
  },
  {
    path: '/recepcion-tecnica/nueva-manual',
    element: <RecepcionManualPage />
  },
  {
    path: '/recepcion-tecnica/editar/:id',
    element: <RecepcionFormPage />
  },
  {
    path: '/recepcion-tecnica/editar-manual/:id',
    element: <RecepcionManualPage />
  },
  {
    path: '/compras/requisiciones/nueva',
    element: <RequisicionFormPage />
  },
  {
    path: '/compras/requisiciones/editar/:id',
    element: <RequisicionFormPage />
  },
  {
    path: '/compras/cotizaciones/nueva',
    element: <CotizacionFormPage />
  },
  {
    path: '/compras/cotizaciones/seleccionar-requisicion',
    element: <SeleccionRequisicionPage />
  },
  {
    path: '/compras/cotizaciones/editar/:id',
    element: <CotizacionFormPage />
  },
  {
    path: '/compras/cotizaciones/completar/:id',
    element: <CompletarCotizacionPage />
  },
  {
    path: '/compras/ordenes',
    element: <OrdenesCompraPage />
  },
  {
    path: '/inventario',
    element: <InventarioPage />
  },
  {
    path: '/dispensacion/nueva',
    element: <NuevaDispensacionPage />
  },
  {
    path: '/dispensacion/editar/:id',
    element: <NuevaDispensacionPage /> // Reusing for now, will create EditarDispensacionPage if needed or adapt Nueva to handle both
  },
  {
    path: '/dispensacion/entregapendientes/:id',
    element: <EntregaPendientesPage />
  },
  {
    path: '/dispensacion',
    element: <DispensacionPage />
  },
  {
    path: '/dispensacion-formula',
    element: <ListadoPacientesFormulaPage />
  },
  {
    path: '/dispensacion-formula/paciente/:pacienteId',
    element: <PerfilPacienteFormulaPage />
  },
  {
    path: '/dispensacion-formula/paciente/:pacienteId/formula/:formulaId',
    element: <DispensacionFormulaOperativaPage />
  },
  {
    path: '/dispensacion-formula/entregapendientes/:formulaId',
    element: <EntregaPendientesFormulaPage />
  },
  {
    path: '/traslados/nuevo',
    element: <NuevoTrasladoPage />
  },
  {
    path: '/traslados/editar/:id',
    element: <NuevoTrasladoPage />
  },
  {
    path: '/traslados/recibir/:id',
    element: <RecepcionTrasladoPage />
  },
  {
    path: '/traslados',
    element: <TrasladosPage />
  },
  {
    path: '/reportes',
    element: <ReportesPage />
  },
  {
    path: '/reportes/dispensaciones',
    element: <ReporteDispensacionesPage />
  },
  {
    path: '/reportes/pendientes',
    element: <ReportePendientesPage />
  },
  {
    path: '/reportes/inventario',
    element: <ReporteInventarioPage />
  },
  {
    path: '/reportes/vencimientos',
    element: <ReporteVencimientosPage />
  },
  {
    path: '/reportes/pt030',
    element: <ReportePT030Page />
  },
  {
    path: '/gestion-especial',
    element: <GestionEspecialPage />
  },
  {
    path: '/usuarios',
    element: <UsuariosPage />
  },
  {
    path: '/bodegas',
    element: <BodegasPage />
  },
  {
    path: '/seleccion-bodega',
    element: <SeleccionBodegaPage />
  },
  {
    path: '/maestro-lotes',
    element: <MaestroLotesPage />
  },
  {
    path: '/pacientes',
    element: <PacientesPage />
  },
  {
    path: '/pacientes/dispensaciones/:cedula',
    element: <DispensacionesPacientePage />
  },
  {
    path: '/devoluciones',
    element: <DevolucionesPage />
  },
  {
    path: '/devoluciones/nueva',
    element: <NuevaDevolucionPage />
  },
  {
    path: '/perfil',
    element: <PerfilPage />
  },
  {
    path: '/laboratorios',
    element: <LaboratoriosPage />
  },
  {
    path: '/medicamentos-vigentes',
    element: <MedicamentosVigentesPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
